interface ProgressBarProps {
  progress: number;
  count: number;
}

export function ProgressBar({ progress, count }: ProgressBarProps) {
  return (
    <div className="w-1/2 flex items-center gap-2">
      <div className="flex-1 bg-muted rounded-full h-2">
        <div
          className="bg-primary h-2 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="w-12 text-right text-sm text-muted-foreground">
        {count}
      </div>
    </div>
  );
}